import external from './external';
import profile from './profile';
import project from './project';
import developer from './developer';

export default {
  external,
  profile,
  project,
  developer,
};
